var MDA_HANDOUT, MDA_TABLE, MDA_TABLE_PREFIX, MDA_TOPIC, MDA_TOPIC_PREFIX, MDGSearchStrategyDoc, MDG_QUESTION_PREFIX, MDG_SEARCH_STRATEGY_PREFIX, MINI_DS_PREFIX, MdaTableDoc, MdaTopicDoc, MdgQuestionDoc, MiniDsDoc, Outcome, OverarchingQuestionDoc, QUESTION_DOC_BY_TYPE, QUESTION_DOC_TYPES, QuestionDoc, QuestionGroupsActions, QuestionsActions, QuestionsStatusesActions, SectionDoc, W, addOutcomeTagAndOutcome, alt, callMethod, convertToList, createOutcomeFromTag, createTag, deleteConnectionsFromDocumentSectionsAndRecommendations, docInstSetAt, docInstUpdateAt, generateGUID, get, getDocByPrefix, getMaxQuestionsOrdering, getNextOutcomeOrderNumber, getOutcomeTagIds, getOutcomesByTagOrder, getPrefixForDocType, getRecommendationsToUpdateWithRelatedTableWithQuestionId, includedTagAdder, markDocumentSectionsWithQuestionIdAsDeleted, mdaHelper, mediator, moveIncludedTag, moveOutcomeTagAndOutcome, prefixDocMapper, prefixesByType, prepareCode, prepareTagCode, questionMappers, questionsOrderingUpdate, removeIncludedTag, removeItemById, removeOutcomeForTag, set, showUndoNotification, stripHTML, syncLiveQuestionModel, updateGroupsDoc, updateIncludedTag, updateIncludedTags, updateOutcomeFieldForTag, updateOutcomeForTag, whereId, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

alt = require('alt');

callMethod = require('base/lib/utils').callMethod;

_ref = require('lodash'), get = _ref.get, set = _ref.set;

mdaHelper = require('lib/mda_helper');

MdaTableDoc = require('lib/db_docs/mda_table_doc');

MdaTopicDoc = require('lib/db_docs/mda_topic_doc');

MiniDsDoc = require('lib/db_docs/mini_ds_doc');

MdgQuestionDoc = require('lib/db_docs/mdg_question_doc');

MDGSearchStrategyDoc = require('lib/db_docs/mdg_search_strategy_doc');

mediator = require('mediator');

OverarchingQuestionDoc = require('lib/db_docs/overarching_question_doc');

Outcome = require('models/outcome');

QuestionsStatusesActions = require('actions/questions_statuses_actions');

QuestionDoc = require('lib/db_docs/question_doc');

QuestionGroupsActions = require('actions/question_groups_actions');

SectionDoc = require('lib/db_docs/document_sections_v2_section_doc');

W = require('when');

_ref1 = require('lib/db_docs/doc_types'), MDA_HANDOUT = _ref1.MDA_HANDOUT, MDA_TOPIC = _ref1.MDA_TOPIC, MDA_TABLE = _ref1.MDA_TABLE;

_ref2 = require('lib/doc_prefixes'), MDA_TABLE_PREFIX = _ref2.mdaTable, MDA_TOPIC_PREFIX = _ref2.mdaTopic, MDG_QUESTION_PREFIX = _ref2.mdgQuestion, MINI_DS_PREFIX = _ref2.miniDsDoc, MDG_SEARCH_STRATEGY_PREFIX = _ref2.mdgSearchStrategy;

whereId = require('lib/lens_utils').whereId;

_ref3 = require('lib/db_docs/document_instance_helpers'), docInstUpdateAt = _ref3.docInstUpdateAt, docInstSetAt = _ref3.docInstSetAt, removeItemById = _ref3.removeItemById;

generateGUID = require('base/lib/utils').generateGUID;

_ref4 = require('lib/questions_helper'), QUESTION_DOC_TYPES = _ref4.QUESTION_DOC_TYPES, prepareCode = _ref4.prepareCode;

_ref5 = require('lib/question_tags_helper'), convertToList = _ref5.convertToList, createTag = _ref5.createTag, includedTagAdder = _ref5.includedTagAdder, moveIncludedTag = _ref5.moveIncludedTag, removeIncludedTag = _ref5.removeIncludedTag, stripHTML = _ref5.stripHTML, updateIncludedTag = _ref5.updateIncludedTag;

_ref6 = require('lib/question_groups_helper'), updateGroupsDoc = _ref6.updateGroupsDoc, questionsOrderingUpdate = _ref6.questionsOrderingUpdate, getMaxQuestionsOrdering = _ref6.getMaxQuestionsOrdering;

syncLiveQuestionModel = function(questionId, questionDoc) {
  var outcomes, questionModel, _ref7;
  questionModel = (_ref7 = mediator.questions) != null ? _ref7.get(questionId) : void 0;
  if (!((questionModel != null) && (questionDoc != null))) {
    return questionDoc;
  }
  outcomes = questionModel.get('outcomes');
  if (((outcomes != null ? outcomes.reset : void 0) != null) && (questionDoc.outcomes != null)) {
    outcomes.reset(questionDoc.outcomes);
  }
  questionModel.set(_.omit(questionDoc, 'outcomes'));
  return questionDoc;
};

updateIncludedTags = function(questionId, updater) {
  var projectId;
  projectId = mediator.project.id;
  return QuestionDoc.at(projectId, questionId).updateAsInstance(docInstUpdateAt('includedTags')(function(includedTags) {
    return updater(Immutable.fromJS(convertToList(includedTags))).toJS();
  })).then(function(questionDoc) {
    return syncLiveQuestionModel(questionId, questionDoc);
  });
};

prepareTagCode = function(code) {
  return Immutable.fromJS({
    id: code.get('@id') || code.get('id'),
    codeType: code.get('@type') || code.get('codeType'),
    value: stripHTML(code.get('value')),
    name: stripHTML(code.get('name'))
  });
};

getNextOutcomeOrderNumber = function(outcomes) {
  var orderNumbers, _ref7;
  orderNumbers = _.chain(outcomes).pluck('orderNumber').filter(_.isNumber).value();
  return ((_ref7 = _.max(orderNumbers.concat([0]))) != null ? _ref7 : 0) + 1;
};

createOutcomeFromTag = function(tag, outcomes) {
  var outcomeAttrs;
  outcomeAttrs = {
    _id: tag.get('id'),
    orderNumber: getNextOutcomeOrderNumber(outcomes)
  };
  if (!_.isEmpty(tag.get('name'))) {
    outcomeAttrs.name = tag.get('name');
  }
  return new Outcome(outcomeAttrs).toJSON();
};

getOutcomeTagIds = function(tags) {
  return tags.filter(function(tag) {
    return tag.get('type') === 'outcome' && tag.get('included') === true;
  }).map(function(tag) {
    return tag.get('id');
  }).toArray();
};

getOutcomesByTagOrder = function(tags, outcomes) {
  var orderedOutcomes, outcomeTagIds, outcomesById, remainingOutcomes;
  outcomeTagIds = getOutcomeTagIds(tags);
  outcomesById = _.indexBy(outcomes, '_id');
  orderedOutcomes = _.chain(outcomeTagIds).map(function(outcomeId) {
    return outcomesById[outcomeId];
  }).compact().value();
  remainingOutcomes = _.reject(outcomes, function(outcome) {
    var _ref7;
    return _ref7 = outcome._id, __indexOf.call(outcomeTagIds, _ref7) >= 0;
  });
  return _.map(orderedOutcomes.concat(remainingOutcomes), function(outcome, idx) {
    return _.extend({}, outcome, {
      orderNumber: idx + 1
    });
  });
};

addOutcomeTagAndOutcome = function(tagKey) {
  return function(docInst) {
    var outcome, outcomes, tag;
    if (tagKey !== 'outcome') {
      return docInst.updateAt('includedTags')(function(includedTags) {
        return includedTagAdder(null, tagKey)(Immutable.fromJS(convertToList(includedTags))).toJS();
      });
    }
    outcomes = convertToList(docInst.getAt('outcomes'));
    tag = createTag(generateGUID(), tagKey);
    outcome = createOutcomeFromTag(tag, outcomes);
    tag = tag.set('name', outcome.name);
    return docInst.updateAt('includedTags')(function(includedTags) {
      return Immutable.fromJS(convertToList(includedTags)).push(tag).toJS();
    }).updateAt('outcomes')(function(currentOutcomes) {
      return convertToList(currentOutcomes).concat([outcome]);
    });
  };
};

removeOutcomeForTag = function(tag) {
  return function(docInst) {
    if (tag.get('type') !== 'outcome') {
      return docInst.updateAt('includedTags')(function(includedTags) {
        return removeIncludedTag(tag)(Immutable.fromJS(convertToList(includedTags))).toJS();
      });
    }
    return docInst.updateAt('includedTags')(function(includedTags) {
      return removeIncludedTag(tag)(Immutable.fromJS(convertToList(includedTags))).toJS();
    }).updateAt('outcomes')(function(outcomes) {
      var currentOutcomes;
      currentOutcomes = convertToList(outcomes);
      return _.reject(currentOutcomes, function(outcome) {
        return outcome._id === tag.get('id');
      });
    });
  };
};

updateOutcomeForTag = function(tag) {
  return function(docInst) {
    if (tag.get('type') !== 'outcome') {
      return docInst.updateAt('includedTags')(function(includedTags) {
        return updateIncludedTag(tag)(Immutable.fromJS(convertToList(includedTags))).toJS();
      });
    }
    return docInst.updateAt('includedTags')(function(includedTags) {
      return updateIncludedTag(tag)(Immutable.fromJS(convertToList(includedTags))).toJS();
    }).updateAt('outcomes')(function(outcomes) {
      var currentOutcomes;
      currentOutcomes = convertToList(outcomes);
      return _.map(currentOutcomes, function(outcome) {
        if (outcome._id === tag.get('id')) {
          return _.extend({}, outcome, {
            name: tag.get('name')
          });
        } else {
          return outcome;
        }
      });
    });
  };
};

updateOutcomeFieldForTag = function(_arg) {
  var fieldKey, fields, tag, value;
  tag = _arg.tag, fieldKey = _arg.fieldKey, value = _arg.value, fields = _arg.fields;
  return function(docInst) {
    return docInst.updateAt('outcomes')(function(outcomes) {
      var currentOutcomes;
      currentOutcomes = convertToList(outcomes);
      if (tag.get('type') !== 'outcome') {
        return currentOutcomes;
      }
      return _.map(currentOutcomes, function(outcome) {
        var updatedFields;
        if (outcome._id === tag.get('id')) {
          updatedFields = _.extend({}, fields);
          if (fields == null) {
            updatedFields[fieldKey] = value;
          }
          return _.extend({}, outcome, updatedFields);
        } else {
          return outcome;
        }
      });
    });
  };
};

moveOutcomeTagAndOutcome = function(_arg) {
  var dragIndex, hoverIndex;
  dragIndex = _arg.dragIndex, hoverIndex = _arg.hoverIndex;
  return function(docInst) {
    var currentOutcomes, orderedOutcomes, updatedIncludedTags;
    updatedIncludedTags = moveIncludedTag({
      dragIndex: dragIndex,
      hoverIndex: hoverIndex
    })(Immutable.fromJS(convertToList(docInst.getAt('includedTags'))));
    currentOutcomes = convertToList(docInst.getAt('outcomes'));
    orderedOutcomes = getOutcomesByTagOrder(updatedIncludedTags, currentOutcomes);
    if (_.isEmpty(currentOutcomes) || _.isEmpty(orderedOutcomes)) {
      return docInst.updateAt('includedTags')(function() {
        return updatedIncludedTags.toJS();
      });
    }
    return docInst.updateAt('includedTags')(function() {
      return updatedIncludedTags.toJS();
    }).updateAt('outcomes')(function() {
      return orderedOutcomes;
    });
  };
};

getDocByPrefix = function(docId) {
  if (mediator.services.switches.isOn('mdgTables')) {
    return MdgQuestionDoc;
  }
  return _.reduce([[MDA_TABLE_PREFIX, MdaTableDoc], [MDA_TOPIC_PREFIX, MdaTopicDoc], [MDG_QUESTION_PREFIX, MdgQuestionDoc], [MINI_DS_PREFIX, MiniDsDoc]], function(acc, _arg) {
    var doc, prefix;
    prefix = _arg[0], doc = _arg[1];
    if (docId.indexOf(prefix) === 0) {
      return doc;
    } else {
      return acc;
    }
  }, QuestionDoc);
};

prefixesByType = {
  mdaTable: MDA_TABLE_PREFIX,
  mdaTopic: MDA_TOPIC_PREFIX,
  mdgQuestion: MDG_QUESTION_PREFIX
};

getPrefixForDocType = function(docType) {
  var _ref7;
  return (_ref7 = prefixesByType[docType]) != null ? _ref7 : '';
};

prefixDocMapper = function(_arg) {
  var rows;
  rows = _arg.rows;
  return _.pluck(rows, 'doc');
};

questionMappers = {
  mdaTopic: prefixDocMapper,
  mdaTable: prefixDocMapper,
  mdaHandout: prefixDocMapper,
  miniDocument: prefixDocMapper,
  mdgQuestion: prefixDocMapper
};

QUESTION_DOC_BY_TYPE = {
  miniDocument: MiniDsDoc,
  mdaTable: MdaTableDoc,
  mdaTopic: MdaTopicDoc,
  mdaHandout: MiniDsDoc,
  mdgQuestion: MdgQuestionDoc,
  regular: QuestionDoc
};

showUndoNotification = function(okCb, message) {
  var notification;
  return notification = mediator.dialogs.undo(message || $.t('es:question.deleted')).on('click:undo', function() {
    notification.destroy();
    return okCb();
  });
};

markDocumentSectionsWithQuestionIdAsDeleted = function(projectId, questionId) {
  return SectionDoc.at(projectId).fetchMany().then(function(sections) {
    var parentsToFetch, sectionIds, sectionsToDelete, updatedSections;
    sectionsToDelete = _.filter(sections, function(section) {
      return section.questionId === questionId;
    });
    if (_.isEmpty(sectionsToDelete)) {
      return [];
    }
    sectionIds = _.pluck(sectionsToDelete, '_id');
    parentsToFetch = _.compact(_.pluck(sectionsToDelete, 'parent'));
    updatedSections = _.map(sectionsToDelete, function(section) {
      return {
        _id: section._id,
        _rev: section._rev,
        _deleted: true
      };
    });
    if (_.isEmpty(parentsToFetch)) {
      return updatedSections;
    }
    return mediator.services.storePersistenceAdapter.fetch(projectId, parentsToFetch).then(function(_arg) {
      var parentRows, parents, updatedParents;
      parentRows = _arg.rows;
      parents = _.compact(_.pluck(parentRows, 'doc'));
      updatedParents = _.map(parents, function(parent) {
        parent.sections = _.difference(parent.sections, sectionIds);
        return parent;
      });
      return _.union(updatedParents, updatedSections);
    });
  });
};

getRecommendationsToUpdateWithRelatedTableWithQuestionId = function(projectId, questionId) {
  return W.all([MdgQuestionDoc.at(projectId).fetchMany(), QuestionDoc.at(projectId).fetchMany()]).then(function(_arg) {
    var etdDocsToFetch, mdgQuestionRows, questionDocs, _ref7;
    (_ref7 = _arg[0], mdgQuestionRows = _ref7.rows), questionDocs = _arg[1];
    etdDocsToFetch = _.chain(mdgQuestionRows).pluck('doc').union(questionDocs).compact().map(function(question) {
      var _ref8;
      return (_ref8 = question.recommendationIds) != null ? _ref8 : [];
    }).flatten().uniq().value();
    if (_.isEmpty(etdDocsToFetch)) {
      return [];
    }
    return mediator.services.storePersistenceAdapter.fetch(projectId, etdDocsToFetch).then(function(_arg1) {
      var recommendationRows, recommendations;
      recommendationRows = _arg1.rows;
      recommendations = _.compact(_.pluck(recommendationRows, 'doc'));
      return _.reduce(recommendations, function(acc, recommendation) {
        var mdgRelatedTables, regularRelatedQuestionIds;
        mdgRelatedTables = get(recommendation, 'templateData.conclusions.sections.recommendation.relatedTable', []);
        if (__indexOf.call(mdgRelatedTables, questionId) >= 0) {
          acc.push(set(recommendation, 'templateData.conclusions.sections.recommendation.relatedTable', _.without(mdgRelatedTables, questionId)));
        }
        regularRelatedQuestionIds = get(recommendation, 'templateData.relatedQuestionsIds', []);
        if (__indexOf.call(regularRelatedQuestionIds, questionId) >= 0) {
          acc.push(set(recommendation, 'templateData.relatedQuestionsIds', _.without(regularRelatedQuestionIds, questionId)));
        }
        return acc;
      }, []);
    });
  });
};

deleteConnectionsFromDocumentSectionsAndRecommendations = function(projectId, questionId) {
  return W.all([markDocumentSectionsWithQuestionIdAsDeleted(projectId, questionId), getRecommendationsToUpdateWithRelatedTableWithQuestionId(projectId, questionId)]).then(function(docs) {
    var docsToSave;
    docsToSave = _.flatten(docs);
    if (_.isEmpty(docsToSave)) {
      return;
    }
    return mediator.services.storePersistenceAdapter.bulkDocs(projectId, docsToSave);
  });
};

QuestionsActions = (function() {
  function QuestionsActions() {
    this.generateActions('fetchSuccess', 'fetchError', 'pouchSaveError', 'createQuestionSuccess', 'createQuestionError', 'deleteQuestionSuccess', 'deleteQuestionError', 'undoQuestionDeleteSuccess', 'startQuestionEdit', 'stopQuestionEdit', 'updateQuestionSuccess', 'updateQuestionError', 'duplicateQuestionSuccess', 'duplicateQuestionError', 'getQuestionOverReviewModuleStateSuccess', 'getQuestionOverReviewModuleStateError', 'openMdgCreateQuestionDialog', 'openMdgEditQuestionDialog', 'closeMdgCreateQuestionDialog', 'changeMdgCreateQuestionDialogQuestionType', 'setMdgCreateQuestionDialogQuestionDataField', 'addMdgCreateQuestionDialogCode', 'removeMdgCreateQuestionDialogCode', 'createMdgQuestionSuccess', 'updateMdgQuestionSuccess', 'createMdgQuestionError', 'updateMdgQuestionError');
  }

  QuestionsActions.prototype.dbChange = function(change, _pending, _lastSeq) {
    var doc, _ref7;
    doc = change.doc;
    if (_ref7 = doc.docType, __indexOf.call(QUESTION_DOC_TYPES, _ref7) < 0) {
      return;
    }
    return this.dispatch(change);
  };

  QuestionsActions.prototype.fetch = function(params) {
    var Doc, dbId, projectId, questionType, _ref7;
    if (params == null) {
      params = {};
    }
    dbId = params.dbId, projectId = params.projectId, questionType = params.questionType;
    this.dispatch();
    if (dbId == null) {
      dbId = projectId != null ? projectId : mediator.project.id;
    }
    if (questionType == null) {
      questionType = mediator.services.switches.isOn('mdgTables') ? 'mdgQuestion' : 'regular';
    }
    Doc = QUESTION_DOC_BY_TYPE[questionType];
    if (!Doc) {
      throw new Error("No Doc for type " + questionType);
    }
    return Doc.at(dbId).fetchMany().then((_ref7 = questionMappers[questionType]) != null ? _ref7 : _.identity).then(this.actions.fetchSuccess)["catch"](this.actions.fetchError);
  };

  QuestionsActions.prototype.updateQuestion = function(params) {
    var projectId, questionData, questionId;
    this.dispatch(params);
    projectId = mediator.project.id;
    questionId = params.questionId, questionData = params.questionData;
    return getDocByPrefix(questionId).at(projectId, questionId).update(questionData).then(this.actions.updateQuestionSuccess)["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.addCode = function(_arg) {
    var code, codeGroup, codes, payload, projectId, questionId;
    codeGroup = _arg.codeGroup, payload = _arg.payload;
    projectId = mediator.project.id;
    questionId = payload.parentId, codes = payload.codes;
    code = codes.first();
    return QuestionDoc.at(projectId, questionId).updateAsInstance(docInstSetAt('codes', codeGroup, code.get('@id'))(prepareCode(code)))["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.removeCode = function(_arg) {
    var code, codeGroup, payload, projectId, questionId;
    codeGroup = _arg.codeGroup, payload = _arg.payload;
    projectId = mediator.project.id;
    questionId = payload.parentId, code = payload.code;
    return QuestionDoc.at(projectId, questionId).updateAsInstance(docInstUpdateAt('codes', codeGroup)(removeItemById(code.get('id'))))["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.addIncludedTag = function(_arg) {
    var projectId, questionId, tagKey;
    questionId = _arg.questionId, tagKey = _arg.tagKey;
    projectId = mediator.project.id;
    return QuestionDoc.at(projectId, questionId).updateAsInstance(addOutcomeTagAndOutcome(tagKey)).then(function(questionDoc) {
      return syncLiveQuestionModel(questionId, questionDoc);
    })["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.removeIncludedTag = function(_arg) {
    var projectId, questionId, tag;
    questionId = _arg.questionId, tag = _arg.tag;
    projectId = mediator.project.id;
    return QuestionDoc.at(projectId, questionId).updateAsInstance(removeOutcomeForTag(tag)).then(function(questionDoc) {
      return syncLiveQuestionModel(questionId, questionDoc);
    })["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.moveIncludedTag = function(_arg) {
    var dragIndex, hoverIndex, projectId, questionId;
    questionId = _arg.questionId, dragIndex = _arg.dragIndex, hoverIndex = _arg.hoverIndex;
    projectId = mediator.project.id;
    return QuestionDoc.at(projectId, questionId).updateAsInstance(moveOutcomeTagAndOutcome({
      dragIndex: dragIndex,
      hoverIndex: hoverIndex
    })).then(function(questionDoc) {
      return syncLiveQuestionModel(questionId, questionDoc);
    })["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.updateIncludedTag = function(_arg) {
    var projectId, questionId, tag;
    questionId = _arg.questionId, tag = _arg.tag;
    projectId = mediator.project.id;
    return QuestionDoc.at(projectId, questionId).updateAsInstance(updateOutcomeForTag(tag)).then(function(questionDoc) {
      return syncLiveQuestionModel(questionId, questionDoc);
    })["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.updateIncludedTagOutcomeField = function(_arg) {
    var fieldKey, fields, projectId, questionId, tag, value;
    questionId = _arg.questionId, tag = _arg.tag, fieldKey = _arg.fieldKey, value = _arg.value, fields = _arg.fields;
    projectId = mediator.project.id;
    return QuestionDoc.at(projectId, questionId).updateAsInstance(updateOutcomeFieldForTag({
      tag: tag,
      fieldKey: fieldKey,
      value: value,
      fields: fields
    })).then(function(questionDoc) {
      return syncLiveQuestionModel(questionId, questionDoc);
    })["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.addIncludedTagCode = function(_arg) {
    var code, codes, newCode, payload, questionId, tagId;
    questionId = _arg.questionId, payload = _arg.payload;
    tagId = payload.parentId, codes = payload.codes;
    code = codes.first();
    newCode = prepareTagCode(code);
    return updateIncludedTags(questionId, function(tags) {
      var tagIndex;
      tagIndex = tags.findIndex(function(tag) {
        return tag.get('id') === tagId;
      });
      if (tagIndex === -1) {
        return tags;
      }
      return tags.updateIn([tagIndex, 'codes'], Immutable.Map(), function(tagCodes) {
        return tagCodes.set(newCode.get('id'), newCode);
      });
    })["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.removeIncludedTagCode = function(_arg) {
    var code, payload, questionId, tagId;
    questionId = _arg.questionId, payload = _arg.payload;
    tagId = payload.parentId, code = payload.code;
    return updateIncludedTags(questionId, function(tags) {
      var tagIndex;
      tagIndex = tags.findIndex(function(tag) {
        return tag.get('id') === tagId;
      });
      if (tagIndex === -1) {
        return tags;
      }
      return tags.updateIn([tagIndex, 'codes'], Immutable.Map(), function(tagCodes) {
        return tagCodes["delete"](code.get('id'));
      });
    })["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.updatePlainLanguageSummary = function(data) {
    var outcomeId, projectId, questionId, text;
    questionId = data.questionId, outcomeId = data.outcomeId, text = data.text;
    projectId = mediator.project.id;
    return QuestionDoc.at(projectId, questionId).updateAsInstance(docInstSetAt('outcomes', whereId(outcomeId), 'plain_language_summary')(text))["catch"](this.actions.pouchSaveError);
  };

  QuestionsActions.prototype.createQuestion = function(_arg) {
    var attributes, projectId, questionsCollectionType;
    questionsCollectionType = _arg.questionsCollectionType, attributes = _arg.attributes;
    QuestionDoc = QUESTION_DOC_BY_TYPE[questionsCollectionType];
    projectId = mediator.project.id;
    return QuestionDoc.at(projectId).create(attributes).then((function(_this) {
      return function(createdQuestion) {
        QuestionGroupsActions.updateQuestionPosition({
          questionType: questionsCollectionType,
          qId: createdQuestion['_id'],
          orderNumber: null
        })["finally"](function() {
          return _this.actions.createQuestionSuccess(createdQuestion);
        });
        return createdQuestion;
      };
    })(this))["catch"]((function(_this) {
      return function(err) {
        _this.actions.createQuestionError(err);
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.createQuestions = function(_arg) {
    var projectId, questions, questionsCollectionType;
    questionsCollectionType = _arg.questionsCollectionType, questions = _arg.questions, projectId = _arg.projectId;
    QuestionDoc = QUESTION_DOC_BY_TYPE[questionsCollectionType];
    if (projectId == null) {
      projectId = mediator.project.id;
    }
    return getMaxQuestionsOrdering(questionsCollectionType, projectId).then(function(maxQuestionsOrdering) {
      return QuestionDoc.at(projectId).createMany(questions).then(function(addingResult) {
        var createdQuestions, updater;
        createdQuestions = _.map(questions, function(questionDoc, idx) {
          return _.extend(questionDoc, {
            _id: addingResult[idx].id,
            _rev: addingResult[idx].rev
          });
        });
        updater = function(doc) {
          return _.reduce(createdQuestions, function(acc, questionDoc, idx) {
            var questionUpdater;
            questionUpdater = questionsOrderingUpdate(questionDoc._id, maxQuestionsOrdering + idx + 1);
            return questionUpdater(acc);
          }, doc);
        };
        return updateGroupsDoc(questionsCollectionType, updater, projectId).then(function() {
          return createdQuestions;
        });
      });
    });
  };

  QuestionsActions.prototype.deleteQuestion = function(questionId, showUndo) {
    var confirmOptions, docType, message, question, questionText, successMessage, title, _ref7;
    if (showUndo == null) {
      showUndo = true;
    }
    question = this.alt.stores.QuestionsStore.getQuestion(questionId);
    if (question == null) {
      return;
    }
    docType = question.get('docType');
    _ref7 = (function() {
      switch (docType) {
        case MDA_HANDOUT:
          return {
            questionText: (question != null ? question.get('name') : void 0) || '',
            title: 'delete_handout_confirmation.title',
            message: 'delete_handout_confirmation.message'
          };
        case MDA_TOPIC:
          return {
            questionText: (question != null ? question.get('name') : void 0) || '',
            title: 'delete_topic_confirmation.title',
            message: 'delete_topic_confirmation.message'
          };
        case MDA_TABLE:
          return {
            questionText: (question != null ? question.get('name') : void 0) || '',
            title: 'delete_table_confirmation.title',
            message: 'delete_table_confirmation.message'
          };
        default:
          return {
            questionText: (question != null ? question.get('question') : void 0) || '',
            title: 'delete_question_confirmation.title',
            message: 'delete_question_confirmation.message'
          };
      }
    })(), questionText = _ref7.questionText, title = _ref7.title, message = _ref7.message;
    confirmOptions = {
      title: $.t(title),
      message: $.t(message, {
        question: questionText
      }),
      confirmText: $.t('actions.delete'),
      declineText: $.t('actions.cancel')
    };
    successMessage = (function() {
      switch (docType) {
        case MDA_HANDOUT:
          return $.t('mda:handouts.deleted');
        case MDA_TOPIC:
          return $.t('mda:topics.deleted');
        case MDA_TABLE:
          return $.t('mda:tables.deleted');
        default:
          return $.t('es:question.deleted');
      }
    })();
    return mediator.dialogs.confirm(confirmOptions, (function(_this) {
      return function(confirmed) {
        var etdHelper, projectId;
        if (!confirmed) {
          return;
        }
        projectId = mediator.project.id;
        _this.dispatch(questionId);
        etdHelper = require('lib/etd_helper');
        return getDocByPrefix(questionId).at(projectId, questionId)["delete"]().then(function(deletedQuestion) {
          var groupId, questionType, removeRelatedDocumentsPromise;
          questionType = _this.alt.stores.QuestionsStore.getQuestionType(questionId);
          groupId = _this.alt.stores.QuestionGroupsStore.getGroupId(questionType, questionId);
          if (groupId !== 'questionsWithoutGroup') {
            QuestionGroupsActions.removeQuestionFromGroup({
              questionType: questionType,
              qId: questionId
            });
          }
          removeRelatedDocumentsPromise = deletedQuestion.topicRootId || deletedQuestion.docRootId ? mdaHelper.deleteRelatedDocs(deletedQuestion) : etdHelper.removeRecommendationTable(deletedQuestion.recommendationIds);
          return W.all([removeRelatedDocumentsPromise, QuestionsStatusesActions.removeQuestionStatusesDoc(questionId), deleteConnectionsFromDocumentSectionsAndRecommendations(projectId, questionId)]).then(function(_arg) {
            var deletedRelatedDocuments;
            deletedRelatedDocuments = _arg[0];
            return mediator.services.overReviewService.deleteOverReview(questionId).then(function(deletedOverReview) {
              var undoActionBound;
              if (showUndo) {
                undoActionBound = _this.actions.undoQuestionDelete.bind(_this.actions, {
                  questionType: questionType,
                  questionId: questionId,
                  groupId: groupId
                });
                showUndoNotification(undoActionBound, successMessage);
              }
              _this.actions.deleteQuestionSuccess({
                deletedQuestion: deletedQuestion,
                deletedRelatedDocuments: deletedRelatedDocuments,
                deletedOverReview: deletedOverReview
              });
              return deletedQuestion;
            });
          });
        })["catch"](function(err) {
          _this.actions.deleteQuestionError({
            questionId: questionId,
            err: err
          });
          return _this.actions.pouchSaveError(err);
        });
      };
    })(this));
  };

  QuestionsActions.prototype.undoQuestionDelete = function(_arg) {
    var QuestionsStatusesStore, QuestionsStore, deletedQuestionDoc, etdHelper, groupId, projectId, questionId, questionType, restoredQuestionDoc, _ref7;
    questionId = _arg.questionId, questionType = _arg.questionType, groupId = _arg.groupId;
    etdHelper = require('lib/etd_helper');
    _ref7 = this.alt.stores, QuestionsStore = _ref7.QuestionsStore, QuestionsStatusesStore = _ref7.QuestionsStatusesStore;
    deletedQuestionDoc = QuestionsStore.getDeletedQuestionDoc(questionId);
    if (!deletedQuestionDoc) {
      return;
    }
    projectId = mediator.project.id;
    restoredQuestionDoc = deletedQuestionDoc["delete"]('_deleted').toJS();
    return getDocByPrefix(questionId).at(projectId).save(restoredQuestionDoc).then((function(_this) {
      return function(qDoc) {
        var deletedOverReviewDoc, deletedQuestionsStatusesDoc, deletedRelatedDocuments;
        deletedRelatedDocuments = QuestionsStore.getDeletedRelatedDocuments(questionId);
        deletedOverReviewDoc = QuestionsStore.getDeletedOverReviewDoc(questionId);
        deletedQuestionsStatusesDoc = QuestionsStatusesStore.getDeletedQuestionStatusesDoc(questionId);
        return etdHelper.restoreRelatedDocuments(deletedRelatedDocuments).then(function() {
          return QuestionsStatusesActions.restoreDeletedDoc(deletedQuestionsStatusesDoc);
        }).then(function() {
          if (deletedOverReviewDoc != null) {
            return mediator.services.overReviewService.restoreOverReviewDocument(deletedOverReviewDoc);
          }
        }).then(function() {
          if (groupId !== 'questionsWithoutGroup') {
            QuestionGroupsActions.moveQuestionToGroup({
              questionType: questionType,
              qId: questionId,
              groupId: groupId
            });
          }
          return _this.actions.undoQuestionDeleteSuccess(qDoc);
        });
      };
    })(this))["catch"](this.actions.pouchSaveError);
  };

  QuestionsActions.prototype.duplicateQuestion = function(_arg) {
    var Doc, OverarchingQuestionsStore, QuestionGroupsStore, QuestionsStore, docPrefix, duplicateQuestionData, duplicateQuestionOrderNumber, etdHelper, groupId, newQuestionId, projectId, questionData, questionId, questionType, sourceQuestion, sourceQuestionOrderNumber, type, _ref7;
    questionId = _arg.questionId, type = _arg.type;
    etdHelper = require('lib/etd_helper');
    _ref7 = this.alt.stores, OverarchingQuestionsStore = _ref7.OverarchingQuestionsStore, QuestionsStore = _ref7.QuestionsStore, QuestionGroupsStore = _ref7.QuestionGroupsStore;
    questionType = QuestionsStore.getQuestionType(questionId);
    sourceQuestion = type === 'overarching' ? OverarchingQuestionsStore.getQuestion(questionId) : QuestionsStore.getQuestion(questionId);
    sourceQuestionOrderNumber = QuestionGroupsStore.getQuestionOrderNumber(questionType, questionId);
    questionData = _.omit(sourceQuestion.toJS(), '_id', '_rev', 'orderNumber', 'recommendationIds', 'revManWebReviewId', 'revManWebTableId', 'revManWebAnalysisGroupId', 'revManWebAnalysisGroupName');
    groupId = QuestionGroupsStore.getGroupId(questionType, questionId);
    projectId = mediator.project.id;
    duplicateQuestionOrderNumber = (sourceQuestionOrderNumber != null ? sourceQuestionOrderNumber : sourceQuestion.get('orderNumber', 0)) + 0.01;
    docPrefix = getPrefixForDocType(questionType);
    newQuestionId = !_.isEmpty(docPrefix) ? "" + docPrefix + (generateGUID()) : void 0;
    duplicateQuestionData = _.extend(questionData, {
      orderNumber: duplicateQuestionOrderNumber,
      _id: newQuestionId
    });
    this.dispatch(questionId);
    Doc = type === 'overarching' ? OverarchingQuestionDoc : getDocByPrefix(questionId);
    return Doc.at(projectId).create(duplicateQuestionData).then(function(duplicatedQuestion) {
      return QuestionGroupsActions.updateQuestionPosition({
        groupId: groupId,
        orderNumber: duplicateQuestionOrderNumber,
        qId: duplicatedQuestion['_id'],
        questionType: questionType
      }).then(function() {
        return duplicatedQuestion;
      });
    }).then(function(duplicatedQuestion) {
      var duplicatedQuestionId, recommendationIdsArray, sourceRecommendationIds, _ref8;
      sourceRecommendationIds = (_ref8 = sourceQuestion.get('recommendationIds')) != null ? _ref8 : Immutable.List();
      if (sourceRecommendationIds.isEmpty()) {
        return duplicatedQuestion;
      } else {
        recommendationIdsArray = sourceRecommendationIds.toJS();
        duplicatedQuestionId = duplicatedQuestion['_id'];
        return etdHelper.duplicateRecommendationTable(recommendationIdsArray, duplicatedQuestionId).then(function(recommendationsTable) {
          return Doc.at(projectId, duplicatedQuestionId).update({
            'recommendationIds': [recommendationsTable['_id']]
          });
        });
      }
    }).then(function(duplicatedQuestion) {
      var duplicatedQuestionId, newSearchStrategyId, sourceSearchStrategyId;
      sourceSearchStrategyId = sourceQuestion.get('searchStrategyId', null);
      if (sourceSearchStrategyId) {
        duplicatedQuestionId = duplicatedQuestion['_id'];
        newSearchStrategyId = "" + MDG_SEARCH_STRATEGY_PREFIX + (generateGUID());
        return MDGSearchStrategyDoc.at(projectId, sourceSearchStrategyId).fetch().then(function(originalSearchStrategy) {
          return MDGSearchStrategyDoc.at(projectId).create(_.extend(originalSearchStrategy, {
            _id: newSearchStrategyId,
            _rev: null
          })).then(function(newSearchStrategy) {
            return Doc.at(projectId, duplicatedQuestionId).updateAsInstance(function(doc) {
              return doc.setAt('searchStrategyId')(newSearchStrategyId);
            });
          });
        });
      } else {
        return duplicatedQuestion;
      }
    }).then(function(duplicatedQuestion) {
      var MdaTopicsActions, topicRootId;
      topicRootId = duplicatedQuestion.topicRootId;
      if (topicRootId) {
        MdaTopicsActions = require('actions/mda_topics_actions');
        return MdaTopicsActions.duplicateTopicRootAndChapters(duplicatedQuestion).then(function(duplicatedTopicRoot) {
          return Doc.at(projectId, duplicatedQuestion._id).updateAsInstance(function(doc) {
            return doc.setAt('topicRootId')(duplicatedTopicRoot._id);
          });
        });
      } else {
        return duplicatedQuestion;
      }
    }).then(this.actions.duplicateQuestionSuccess)["catch"]((function(_this) {
      return function(err) {
        _this.actions.duplicateQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.toggleOverReview = function(_arg) {
    var isEnabled, questionId;
    questionId = _arg.questionId, isEnabled = _arg.isEnabled;
    this.dispatch({
      questionId: questionId,
      isEnabled: isEnabled
    });
    return mediator.services.overReviewService.toggleModuleState(questionId, isEnabled);
  };

  QuestionsActions.prototype.toggleCadthPublication = function(questionId) {
    return QuestionDoc.at(mediator.project.id, questionId).updateAsInstance(callMethod('toggleCadthPublication'));
  };

  QuestionsActions.prototype.getQuestionOverReviewModuleState = function(questionId) {
    return mediator.services.overReviewService.isModuleEnabled(questionId).then((function(_this) {
      return function(isEnabled) {
        return _this.actions.getQuestionOverReviewModuleStateSuccess({
          questionId: questionId,
          isEnabled: isEnabled
        });
      };
    })(this))["catch"](this.actions.getQuestionOverReviewModuleStateError);
  };

  QuestionsActions.prototype.createMdgQuestion = function(questionData) {
    var projectId;
    this.dispatch();
    projectId = mediator.project.id;
    return MdgQuestionDoc.at(projectId).create(_.extend({}, questionData, {
      _id: "" + MDG_QUESTION_PREFIX + (generateGUID())
    })).then((function(_this) {
      return function(createdQuestion) {
        QuestionGroupsActions.updateQuestionPosition({
          questionType: 'regular',
          qId: createdQuestion['_id'],
          orderNumber: null
        })["finally"](function() {
          return _this.actions.createMdgQuestionSuccess(createdQuestion);
        });
        return createdQuestion;
      };
    })(this))["catch"]((function(_this) {
      return function(err) {
        _this.actions.createMdgQuestionError(err);
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  QuestionsActions.prototype.updateMdgQuestion = function(params) {
    var projectId, questionData, questionId;
    this.dispatch(params);
    projectId = mediator.project.id;
    questionId = params.questionId, questionData = params.questionData;
    return MdgQuestionDoc.at(projectId, questionId).update(questionData).then(this.actions.updateMdgQuestionSuccess)["catch"]((function(_this) {
      return function(err) {
        _this.actions.updateMdgQuestionError({
          questionId: questionId,
          err: err
        });
        return _this.actions.pouchSaveError(err);
      };
    })(this));
  };

  return QuestionsActions;

})();

module.exports = alt.createActions(QuestionsActions);
